import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./SetNewPassword.css";

const PasswordResetChange = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { email } = location.state 

  const userId = "673f72c124daa756e66378d9";

  const handleOtpChange = (e) => setOtp(e.target.value);
  const handlePasswordChange = (e) => setNewPassword(e.target.value);

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!otp || !newPassword || !userId) {
      setErrorMessage("Please fill in all fields.");
      return;
    }

    try {
      const response = await fetch(`https://admin.riymay.com/api/v1/admin/password-reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ otp, email, newPassword }),
      });

      if (response.ok) {
        alert("Password reset successful!");
        navigate("/");
      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || "Failed to reset password.");
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <h2>Reset Your Password</h2>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <form onSubmit={handlePasswordReset}>
          <div className="input-group">
            <label htmlFor="otp">OTP</label>
            <input
              type="text"
              id="otp"
              value={otp}
              onChange={handleOtpChange}
              placeholder="Enter OTP"
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={handlePasswordChange}
              placeholder="Enter new password"
              required
            />
          </div>
          <button type="submit" className="submit-btn">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetChange;
